"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListLocal = void 0;
const fs_1 = __importDefault(require("fs"));
const APITasks_1 = require("./resources/APITasks");
const FSIServerClientUtils_1 = require("./FSIServerClientUtils");
const ListServer_1 = require("./ListServer");
const APIAbortController_1 = require("./APIAbortController");
const TaskProgress_1 = require("./TaskProgress");
const LogLevel_1 = require("./LogLevel");
class ListLocal {
    constructor(classInit, taskController) {
        this.classInit = classInit;
        this.taskController = taskController;
        this.client = classInit.client;
        this.com = classInit.com;
        this.baseURL = this.client.getServerBaseQuery();
    }
    static async applyFilters(options, ld, entry) {
        const res = {
            passed: true,
            post: true,
            pre: true
        };
        if (options.fnDirFilter && entry.type === "directory" && !await options.fnDirFilter(ld, entry)) {
            res.passed = false;
            res.pre = false;
        }
        if (res.pre && options.fnFileFilter && entry.type === "file" && !await options.fnFileFilter(ld, entry)) {
            res.passed = false;
            res.post = false;
        }
        return res;
    }
    static addDirEntryFromPath(ld, path) {
        const baseDir = FSIServerClientUtils_1.FSIServerClientUtils.EXTRACT_LAST_DIR(path);
        const entry = {
            _listData: ld,
            height: 0,
            lastModified: 0,
            path,
            size: 0,
            src: baseDir.dir,
            type: "directory",
            width: 0,
        };
        ld.entries.push(entry);
        ld.summary.entryCount++;
        ld.summary.directoryCount++;
        ld.summary.clientInfo.entryCount++;
        ld.summary.clientInfo.directoryCount++;
        return entry;
    }
    read(path, options = {}) {
        this.taskController.setCurrentTask(LogLevel_1.LogLevel.debug, APITasks_1.APITasks.readListLocal, [path]);
        const self = this;
        path = FSIServerClientUtils_1.FSIServerClientUtils.TRANSFORM_LOCAL_PATH(path);
        path = FSIServerClientUtils_1.FSIServerClientUtils.NORMALIZE_PATH(path);
        const loopData = {
            blackList: {},
            checkConnectorType: true,
            maxDepth: 0,
            note: "",
            validConnectorTypes: {},
            canceled: false
        };
        if (options.maxRecursiveDepth === undefined) {
            options.maxRecursiveDepth = 255;
        }
        let typeFilter = options.typeFilter || "all";
        if (typeFilter !== "all") {
            if (typeFilter !== "directory") {
                typeFilter = "file";
            }
        }
        const useDirs = (typeFilter === "all" || typeFilter === "directory");
        const useFiles = (typeFilter === "all" || typeFilter === "file");
        return new Promise((resolve, reject) => {
            self.listDataFromLocalDir(path, options, useDirs, useFiles, 0, loopData, 0, 100)
                .then((res) => {
                resolve(res);
            })
                .catch(err => {
                reject(err);
            });
        });
    }
    addItemsFromDataTransferItemList(fl, options = {}) {
        const ld = ListServer_1.ListServer.GET_EMPTY_LIST_DATA();
        ld.summary._baseDir = "";
        ld.summary.connectorType = "LOCAL";
        const self = this;
        let prgSize;
        let prgPos = 0;
        if (options.fnProgress !== undefined || options._fnQueueProgress !== undefined) {
            options._taskProgress = new TaskProgress_1.TaskProgress();
        }
        return new Promise(async (resolve, reject) => {
            const addFile = (entry) => {
                return new Promise((resolveInner) => {
                    APIAbortController_1.APIAbortController.THROW_IF_ABORTED(options.abortController);
                    const addEntry = async (listEntry) => {
                        const resFilter = await ListLocal.applyFilters(options, ld, listEntry);
                        if (resFilter.passed) {
                            ld.entries.push(listEntry);
                            ld.summary.entryCount++;
                            ld.summary.imageCount++;
                            ld.summary.clientInfo.fileCount++;
                            ld.summary.clientInfo.entryCount++;
                            ld.summary.clientInfo.totalSize += listEntry.size;
                        }
                        resolveInner(resFilter);
                    };
                    if (entry.file) {
                        entry.file(async (file) => {
                            const mime = (file && file.type) ? file.type : "";
                            const size = (file) ? file.size : 0;
                            const listEntry = {
                                _listData: ld,
                                file,
                                height: 0,
                                lastModified: file.lastModified,
                                mime,
                                path: entry.fullPath,
                                size,
                                src: entry.name,
                                type: 'file',
                                width: 0
                            };
                            await addEntry(listEntry);
                        }, reject);
                    }
                    else {
                        const mime = entry.type || "";
                        const size = entry.size || 0;
                        const listEntry = {
                            _listData: ld,
                            file: entry,
                            height: 0,
                            lastModified: entry.lastModified,
                            mime,
                            path: entry.name,
                            size,
                            src: entry.name,
                            type: 'file',
                            width: 0
                        };
                        addEntry(listEntry);
                    }
                });
            };
            const addDir = async (entry) => {
                APIAbortController_1.APIAbortController.THROW_IF_ABORTED(options.abortController);
                const listEntry = {
                    _listData: ld,
                    file: null,
                    height: 0,
                    lastModified: 0,
                    mime: "",
                    path: entry.fullPath,
                    size: 0,
                    src: entry.name,
                    type: 'directory',
                    width: 0,
                };
                const resFilter = await ListLocal.applyFilters(options, ld, listEntry);
                if (resFilter.passed) {
                    ld.entries.push(listEntry);
                    ld.summary.entryCount++;
                    ld.summary.directoryCount++;
                    ld.summary.clientInfo.entryCount++;
                    ld.summary.clientInfo.directoryCount++;
                }
                return resFilter;
            };
            const toArray = (list) => {
                return Array.prototype.slice.call(list || [], 0);
            };
            const getSubdirectories = async (entry, dirReader, atLevel, progressStart, progressSize) => {
                ld.summary.clientInfo.maxDepth = Math.max(ld.summary.clientInfo.maxDepth, atLevel);
                return new Promise((resolveInner, rejectInner) => {
                    let added = 0;
                    const onDirEntries = async (results) => {
                        APIAbortController_1.APIAbortController.THROW_IF_ABORTED(options.abortController);
                        if (results.length > 0) {
                            const subSize = progressSize / (added + results.length);
                            const entries = toArray(results);
                            for (const theEntry of entries) {
                                added++;
                                const subStart = progressStart + subSize * added;
                                await consumeEntry(theEntry, atLevel, subStart, subSize);
                            }
                            dirReader.readEntries(onDirEntries, reject);
                        }
                        else {
                            resolveInner(true);
                        }
                    };
                    dirReader.readEntries(onDirEntries, rejectInner);
                });
            };
            const consumeEntry = async (entry, atLevel, pPos, pSize) => {
                if (options._taskProgress) {
                    const task = (entry.isDirectory) ? APITasks_1.APITasks.readSubDir : APITasks_1.APITasks.processFile;
                    self.callProgress(LogLevel_1.LogLevel.trace, options, task, [entry.name, atLevel], pPos, prgSize);
                }
                if (entry.isDirectory === true) {
                    const resFilter = await addDir(entry);
                    if (resFilter.pre && options.recursive) {
                        await getSubdirectories(entry, entry.createReader(), atLevel + 1, pPos, pSize / prgSize);
                    }
                }
                else if (entry.isFile === true) {
                    await addFile(entry);
                }
            };
            const mainEntries = [];
            for (let i = 0; i < fl.length; i++) {
                APIAbortController_1.APIAbortController.THROW_IF_ABORTED(options.abortController);
                const item = fl[i];
                if (item.kind === "file" && item.webkitGetAsEntry) {
                    mainEntries.push(item.webkitGetAsEntry());
                }
                else {
                    const fileItem = fl[i];
                    fileItem.isFile = true;
                    mainEntries.push(fileItem);
                }
            }
            prgSize = mainEntries.length;
            setTimeout(async () => {
                for (let i = 0; i < mainEntries.length; i++) {
                    APIAbortController_1.APIAbortController.THROW_IF_ABORTED(options.abortController);
                    prgPos = i;
                    await consumeEntry(mainEntries[i], 0, prgPos, prgSize);
                }
                return resolve(ld);
            }, 0);
        });
    }
    callProgress(level, options, apiTaskDef, content, pos = 0, length = 0) {
        this.taskController.onStepProgress(level, options, apiTaskDef, content, pos, length);
    }
    listDataFromLocalDir(path, options = {}, useDirs, useFiles, depth = 0, loopData, progressStart, progressSize) {
        this.taskController.setCurrentTask(LogLevel_1.LogLevel.debug, APITasks_1.APITasks.readListLocal, [path]);
        if (options.fnProgress !== undefined || options._fnQueueProgress !== undefined) {
            options._taskProgress = new TaskProgress_1.TaskProgress();
            options._taskProgress.currentTask = this.com.taskSupplier.get(APITasks_1.APITasks.readListLocal, [path]);
        }
        const dirs = [];
        const ld = ListServer_1.ListServer.GET_EMPTY_LIST_DATA();
        ld.summary.connectorType = "LOCAL";
        ld.summary.dir = path;
        if (depth === 0) {
            if (!options.dropEntries)
                ListLocal.addDirEntryFromPath(ld, path);
            else {
                ld.summary.entryCount++;
                ld.summary.directoryCount++;
            }
        }
        const self = this;
        loopData.maxDepth = Math.max(loopData.maxDepth, depth);
        return new Promise((resolve, reject) => {
            APIAbortController_1.APIAbortController.THROW_IF_ABORTED(options.abortController);
            const getSubdirectories = async () => {
                APIAbortController_1.APIAbortController.THROW_IF_ABORTED(options.abortController);
                const prgSize = (dirs.length === 0) ? 0 : progressSize / dirs.length;
                for (let i = 0; i < dirs.length; i++) {
                    const entry = dirs[i];
                    const prgStart = progressStart + prgSize * i;
                    self.callProgress(LogLevel_1.LogLevel.trace, options, APITasks_1.APITasks.readSubDir, [entry.path, depth], prgStart, 100);
                    await self.listDataFromLocalDir(entry.path, options, useDirs, useFiles, depth + 1, loopData, prgStart, prgSize)
                        .then((ldSub) => {
                        APIAbortController_1.APIAbortController.THROW_IF_ABORTED(options.abortController);
                        ld.summary.entryCount += ldSub.summary.entryCount;
                        ld.summary.directoryCount += ldSub.summary.directoryCount;
                        ld.summary.imageCount += ldSub.summary.imageCount;
                        ld.summary.completeCount += ldSub.summary.completeCount;
                        ld.summary.clientInfo.totalSize += ldSub.summary.clientInfo.totalSize;
                        if (!options.dropEntries)
                            ld.entries = ld.entries.concat(ldSub.entries);
                    })
                        .catch(err => {
                        if (this.com.isAbortError(err) || (!options.continueOnError)) {
                            throw err;
                        }
                        if (options._fnQueueError !== undefined) {
                            options._fnQueueError.fn.call(options._fnQueueError.ctx, err);
                        }
                        self.taskController.error(err);
                    });
                }
            };
            const listFinished = () => {
                if (!options.recursive
                    || (options.maxRecursiveDepth === undefined || depth >= options.maxRecursiveDepth)) {
                    return resolve(ld);
                }
                return getSubdirectories().then(() => {
                    if (depth === 0) {
                        if (loopData.note === "") {
                            loopData.note = "complete";
                        }
                        ld.summary.clientInfo.note = loopData.note;
                        ld.summary.clientInfo.maxDepth = loopData.maxDepth;
                        ld.summary.clientInfo.directoryCount = ld.summary.directoryCount;
                        ld.summary.clientInfo.fileCount = ld.summary.imageCount;
                        ld.summary.clientInfo.entryCount = ld.summary.entryCount;
                        this.taskController.resetSubTask();
                    }
                    return resolve(ld);
                })
                    .catch(err => {
                    reject(err);
                });
            };
            const onResult = (err, res) => {
                if (err !== null) {
                    reject(err);
                }
                else {
                    let i = 0;
                    const nextEntry = () => {
                        if (i === res.length) {
                            listFinished();
                        }
                        else {
                            APIAbortController_1.APIAbortController.THROW_IF_ABORTED(options.abortController);
                            let entryPath = path + res[i];
                            fs_1.default.stat(entryPath, async (error, stat) => {
                                if (error) {
                                    self.taskController.errorNative(error);
                                }
                                else {
                                    let type = null;
                                    if (stat.isDirectory()) {
                                        entryPath = FSIServerClientUtils_1.FSIServerClientUtils.NORMALIZE_PATH(entryPath);
                                        if (useDirs) {
                                            type = "directory";
                                        }
                                    }
                                    else if (stat.isFile()) {
                                        if (useFiles) {
                                            type = "file";
                                        }
                                    }
                                    if (type) {
                                        const entry = {
                                            _listData: ld,
                                            height: 0,
                                            lastModified: Math.floor(stat.mtimeMs),
                                            path: entryPath,
                                            size: stat.size,
                                            src: res[i],
                                            type,
                                            width: 0,
                                        };
                                        const resFilter = await ListLocal.applyFilters(options, ld, entry);
                                        if (resFilter.pre) {
                                            if (type === "directory") {
                                                dirs.push(entry);
                                            }
                                        }
                                        if (resFilter.passed) {
                                            ld.summary.entryCount++;
                                            if (!options.dropEntries)
                                                ld.entries.push(entry);
                                            if (type === "file") {
                                                ld.summary.imageCount++;
                                                ld.summary.clientInfo.totalSize += entry.size;
                                            }
                                            else {
                                                ld.summary.directoryCount++;
                                            }
                                        }
                                    }
                                }
                                i++;
                                nextEntry();
                            });
                        }
                    };
                    nextEntry();
                }
            };
            fs_1.default.readdir(path, { withFileTypes: false }, onResult);
        });
    }
}
exports.ListLocal = ListLocal;
